var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRemise = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3216 57.376L57.3634 44.3341L64.2179 51.1885L51.176 64.2304L44.3216 57.376Z",
    fill: "#FF8484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.623 63.246C49.0879 63.246 63.246 49.0879 63.246 31.623C63.246 14.1581 49.0879 0 31.623 0C14.1581 0 0 14.1581 0 31.623C0 49.0879 14.1581 63.246 31.623 63.246Z",
    fill: "#E23232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.623 55.3402C44.7217 55.3402 55.3402 44.7217 55.3402 31.623C55.3402 18.5243 44.7217 7.90576 31.623 7.90576C18.5243 7.90576 7.90576 18.5243 7.90576 31.623C7.90576 44.7217 18.5243 55.3402 31.623 55.3402Z",
    fill: "#FFC0C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1169 31.623L47.922 36.9199L43.3498 40.148L41.6896 45.4844L36.1029 45.4054L31.623 48.7521L27.1431 45.4054L21.5563 45.4844L19.8961 40.148L15.324 36.9199L17.1291 31.623L15.324 26.3262L19.8961 23.098L21.5563 17.7616L27.1431 17.8407L31.623 14.4939L36.1029 17.8407L41.6896 17.7616L43.3498 23.098L47.922 26.3262L46.1169 31.623Z",
    fill: "#E23232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3525 30.3054C27.8079 30.3054 28.9877 29.1256 28.9877 27.6702C28.9877 26.2148 27.8079 25.0349 26.3525 25.0349C24.8971 25.0349 23.7172 26.2148 23.7172 27.6702C23.7172 29.1256 24.8971 30.3054 26.3525 30.3054Z",
    fill: "#FF9E9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8935 38.2112C38.3489 38.2112 39.5287 37.0313 39.5287 35.5759C39.5287 34.1205 38.3489 32.9407 36.8935 32.9407C35.4381 32.9407 34.2582 34.1205 34.2582 35.5759C34.2582 37.0313 35.4381 38.2112 36.8935 38.2112Z",
    fill: "#FF9E9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3698 53.0515L53.0515 62.3698L65.1644 74.4814C66.4018 75.7079 68.0746 76.3944 69.8169 76.3906C71.5592 76.3868 73.229 75.693 74.461 74.461C75.693 73.229 76.3868 71.5592 76.3906 69.8169C76.3944 68.0746 75.7079 66.4018 74.4814 65.1644L62.3698 53.0515Z",
    fill: "#FFB0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6701 39.5287C27.437 39.5284 27.2082 39.4663 27.0069 39.3487C26.8056 39.231 26.6392 39.0622 26.5245 38.8592C26.4098 38.6563 26.3511 38.4265 26.3542 38.1934C26.3573 37.9604 26.4222 37.7323 26.5422 37.5325L34.448 24.3562C34.6312 24.0635 34.922 23.8543 35.2578 23.7738C35.5936 23.6934 35.9476 23.7479 36.2436 23.9258C36.5396 24.1037 36.754 24.3906 36.8405 24.725C36.9271 25.0593 36.8789 25.4142 36.7064 25.7134L28.8006 38.8896C28.6834 39.0847 28.5177 39.2461 28.3196 39.3581C28.1215 39.4701 27.8977 39.5288 27.6701 39.5287Z",
    fill: "#FF9E9E"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemise, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/remise.fc7533ec.svg";
export { ForwardRef as ReactComponent };